/* Insights hub and article chrome (visual audit, 21 Oct 2026). REVIEW-BG draft.
 * Article bodies, titles and excerpts stay in English; the layout marks
 * them lang="en" and shows a note on /bg/. */
import type { Language } from "@/lib/i18n";
import type { InsightTag } from "@/lib/insights/types";
import { TAG_LABELS } from "@/lib/insights/types";
import type { Catalogue } from "./index";

export const TAG_LABELS_BG: Record<InsightTag, string> = {
  dwdm: "DWDM",
  "submarine-cables": "Подводни кабели",
  "ip-transit": "IP Transit",
  routing: "Маршрутизация и BGP",
  regulation: "Регулация",
  "m-and-a": "Сливания и придобивания",
  bulgaria: "България",
  caucasus: "Кавказ",
  "eu-funding": "Европейско финансиране",
  peering: "Пиъринг",
  security: "Сигурност",
};

export function tagLabel(tag: InsightTag, lang: Language): string {
  return lang === "bg" ? TAG_LABELS_BG[tag] : TAG_LABELS[tag];
}

export function formatInsightDate(iso: string, lang: Language, long = false): string {
  const d = new Date(`${iso}T00:00:00Z`);
  return d.toLocaleDateString(lang === "bg" ? "bg-BG" : "en-GB", {
    day: "numeric",
    month: long ? "long" : "short",
    year: "numeric",
    timeZone: "UTC",
  });
}

/** "5 min read" (from reading-time) → "5 мин. четене" on /bg/. */
export function readingTimeLabel(text: string, lang: Language): string {
  if (lang !== "bg") return text;
  const m = text.match(/(\d+)/);
  return m ? `${m[1]} мин. четене` : text;
}

export const INSIGHTS_BG: Catalogue = {
  // Hub
  "Industry Analysis · Weekly": "Анализи на отрасъла · Всяка седмица",
  Insights: "Анализи",
  "Weekly analysis on DWDM, IP transit, submarine cables, peering, and telecom regulation — written for carrier, ISP and enterprise network decision-makers. Curated by the Sofia Connect team.":
    "Седмични анализи за DWDM, IP транзит, подводни кабели, пиъринг и регулация в телекомуникациите. Пишем ги за хората, които вземат решения за мрежи на оператори, интернет доставчици и компании. Подбира ги екипът на Sofia Connect.",
  "Subscribe via RSS": "Абонамент чрез RSS",
  All: "Всички",
  "Search insights": "Търсене в анализите",
  "Search insights…": "Търсене в анализите…",
  "No insights match these filters yet.": "Няма анализи, които да отговарят на тези филтри.",
  "Clear filters": "Изчисти филтрите",
  "Articles are published in English.": "Статиите се публикуват на английски.",

  // Article layout
  Breadcrumb: "Навигационна пътека",
  "The article is available in English only.": "Статията е налична само на английски.",
  "All insights": "Всички анализи",
  "Share on LinkedIn": "Сподели в LinkedIn",
  "Related insights": "Още анализи",
  "View all insights tagged": "Всички анализи с етикет",

  // Table of contents
  "Table of contents": "Съдържание",
  "On this page": "На тази страница",

  // Subscribe form
  "Sofia Connect Insights": "Анализи от Sofia Connect",
  "Weekly analysis on regional telecom infrastructure": "Седмичен анализ на телеком инфраструктурата в региона",
  "DWDM, submarine cables, IP transit, peering, regulation, M&A — one email per week, written for engineers and decision-makers. No marketing.":
    "DWDM, подводни кабели, IP транзит, пиъринг, регулация, сделки. Един имейл седмично, за инженери и мениджъри. Без реклама.",
  "You're subscribed. A welcome email is on its way.": "Абонирахте се. Ще получите приветствен имейл.",
  "Email address": "Имейл адрес",
  "Subscribing…": "Абониране…",
  Subscribe: "Абонирай се",
  "Please enter a valid email address.": "Въведете валиден имейл адрес.",
  "Something went wrong. Please try again.": "Нещо се обърка. Опитайте отново.",
  "Network error. Please try again.": "Грешка в мрежата. Опитайте отново.",
  "By subscribing you agree to receive emails from Sofia Connect EAD. You can unsubscribe at any time.":
    "С абонирането се съгласявате да получавате имейли от Sofia Connect EAD. Може да се отпишете по всяко време.",
  Privacy: "Поверителност",

  // Tag page
  Tag: "Етикет",
  "Tag not found": "Етикетът не е намерен",
  "insight in this category.": "анализ в тази категория.",
  "insights in this category.": "анализа в тази категория.",

  // Authors
  "CEO, Sofia Connect EAD · Honorary Consul of Georgia in Bulgaria":
    "Изпълнителен директор на Sofia Connect EAD · Почетен консул на Грузия в България",
  "Editorial Team": "Редакционен екип",
  "Sofia Connect Team": "Екипът на Sofia Connect",
};
